<script setup>
/**
 * FormPageContentField
 * Fetches and displays a Content record's title and its associated type label.
 * Primarily used within lists or forms to reference linked content blocks.
 */
import { getCurrentInstance } from 'vue';
import ContentTypeLabel from '../ContentTypeLabel';

const props = defineProps({
    contentId: {
        type: Number,
        required: true
    }
});

const { proxy } = getCurrentInstance();
</script>

<script>
/**
 * Note: asyncComputed is an Options-API based plugin.
 * We keep the data fetching logic here to ensure compatibility.
 */
export default {
    asyncComputed: {
        async content() {
            if (!this.contentId) return null;
            return await this.$store.dispatch('itemData/get', {
                tableName: 'content',
                id: this.contentId
            });
        }
    }
}
</script>

<template>
    <span>
        {{ content?.title }}
        <ContentTypeLabel
            v-if="content"
            :content-type-id="content.contentType"
            class="ms-1"
        />
    </span>
</template>